'use client'
import React, { useCallback, useMemo } from 'react'
import { InputSelect } from '../InputSelect'
import styles from './styles.module.scss'
import { generateYears } from '@l2p/apps-shared'
import { IOption } from '../InputSelect/InputSelect'
import { CaptionElementProps } from 'react-day-picker/types/Props'

export interface YearMonthFormProps
  extends Pick<CaptionElementProps, 'date' | 'localeUtils'> {
  onChange: (date: Date) => void
  chosenDay: Date
}
const YearMonthForm: React.FC<YearMonthFormProps> = ({
  date,
  localeUtils,
  onChange,
  chosenDay,
}) => {
  const yearsOptions = useMemo(() => generateYears(), [])

  const changeYearHandler = useCallback(
    (data: IOption) => {
      onChange(
        new Date(Number(data.value), date.getMonth(), chosenDay.getDate()),
      )
    },
    [onChange, date, chosenDay],
  )

  return (
    <div className="DayPicker-Caption">
      <div className={styles.captionContainer}>
        <div> {localeUtils.getMonths()[date.getMonth()]}</div>
        <InputSelect
          options={yearsOptions}
          onChange={changeYearHandler}
          value={yearsOptions.find(item => item.value === date.getFullYear())}
          isSearchable={false}
          hideSelectedOptions={false}
        />
      </div>
    </div>
  )
}

export default YearMonthForm
